import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularFontAwesomeModule } from 'angular-font-awesome';

import { HttpClientModule } from '@angular/common/http';
// import { HttpModule } from '@angular/http';

// routes
import { AppRoutingModule } from './app-routing.module';

// servicios
import { ContactoService } from './services/contacto.service';
import { InicioService } from './services/inicio.service';


// Componentes
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ContactoComponent } from './pages/contacto/contacto.component';
import { Pagina3Component } from './pages/pagina3/pagina3.component';
import { SeguimientoComponent } from './pages/seguimiento/seguimiento.component';



// Loading ng
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { DocumentosAuditoriaComponent } from './pages/documentos-auditoria/documentos-auditoria.component';
import { PagenotfoundComponent } from './pages/pagenotfound/pagenotfound.component';



@NgModule({
  declarations: [
    AppComponent,
    SeguimientoComponent,
    ContactoComponent,
    Pagina3Component,
    NavbarComponent,
    DocumentosAuditoriaComponent,
    PagenotfoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    FontAwesomeModule,
    AngularFontAwesomeModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    // HttpModule,

    // RegistroModule

    
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
        backdropBackgroundColour: 'rgba(7,49,80,0.2)', 
        backdropBorderRadius: '4px',
        fullScreenBackdrop:true,
        primaryColour: '#073150', 
        secondaryColour: '#073150', 
        tertiaryColour: '#073150'
    })
  ],
  providers: [
    InicioService,
    ContactoService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
